import * as React from 'react'
import * as R from 'ramda'
import {PrintStatus} from '../../../View/InquiryStatusDisplay'
import {LocalDateTime} from 'js-joda'
import {
    InquiryHistoryEntryWithUsers,
    userDisplayName
} from '../../../Entities/InquiryHistoryEntryWithUsers'
import {InquiryCommentWithUsers} from '../../../Entities/InquiryCommentWithUsers'
import {InquiryStatusChangeWithUsers} from '../../../Entities/InquiryStatusChangeWithUsers'
import {BpsUser} from '../../../Entities/BpsUser'
import {minuteDateTimeFormatter} from '../../../View/Utils'

export function InquiryHistoryView({history, inquiryCreated, inquiryUser}: {
    history: InquiryHistoryEntryWithUsers[],
    inquiryCreated: LocalDateTime
    inquiryUser: BpsUser
}) {
    return (
        <div
            className="state-history__wrapper"
            id="history-scroll-view"
        >
            <div className="state-history__content">
                <Bubble
                    customerAction={true}
                    created={inquiryCreated}
                    user={''}
                >
                    <div className="history-bubble__message">
                        Die Anfrage wurde&#x20;
                        <PrintStatus inquiryStatus={'requested'}/>
                    </div>
                </Bubble>
                {R.map(
                    (entry: InquiryHistoryEntryWithUsers) => {
                        switch (entry.type) {
                            case 'Comment':
                                return <InquiryCommentView
                                    key={`comment-${entry.comment.inquiryComment.id}`}
                                    inquiryCommentWithUsers={entry.comment}
                                />
                            case 'StatusChange':
                                return <InquiryCommentedStatusChangeView
                                    key={`commented-status-change-${entry.statusChange.inquiryStatusChange.id}`}
                                    inquiryStatusChangeWithUsers={entry.statusChange}
                                />
                        }
                    },
                    history,
                )}
            </div>
        </div>
    )
}

function InquiryCommentView({inquiryCommentWithUsers}: {
    inquiryCommentWithUsers: InquiryCommentWithUsers
}) {
    const {inquiryComment} = inquiryCommentWithUsers
    return (
        <Bubble
            customerAction={inquiryComment.bpsUserId !== null}
            created={inquiryComment.created}
            user={userDisplayName(inquiryCommentWithUsers)}
        >
            {inquiryComment.text}
        </Bubble>
    )
}

function InquiryCommentedStatusChangeView({inquiryStatusChangeWithUsers}: {
    inquiryStatusChangeWithUsers: InquiryStatusChangeWithUsers,
}) {
    const {inquiryStatusChange} = inquiryStatusChangeWithUsers
    return (
        <Bubble
            customerAction={inquiryStatusChange.newStatus !== 'inApproval'}
            created={inquiryStatusChange.created}
            user={userDisplayName(inquiryStatusChangeWithUsers)}
        >
            {(() => {
                switch (inquiryStatusChange.statusType) {
                    case 'proofCopyStatus':
                        return (
                            <div>
                                {inquiryStatusChangeWithUsers.inquiryStatusChange.comment}
                                <div className="history-bubble__message">
                                    Der Korrekturabzugsstatus wurde zu&#x20;
                                    <PrintStatus
                                        inquiryStatus={inquiryStatusChange.newStatus}
                                    />&#x20;
                                    geändert
                                </div>
                            </div>
                        )
                    case 'offerStatus':
                        return (
                            <div>
                                {inquiryStatusChangeWithUsers.inquiryStatusChange.comment}
                                <div className="history-bubble__message">
                                    Der Angebotsstatus wurde zu&#x20;
                                    <PrintStatus
                                        inquiryStatus={inquiryStatusChange.newStatus}
                                    />&#x20;
                                    geändert
                                </div>
                            </div>
                        )
                }
            })()}
        </Bubble>
    )
}

function Bubble({customerAction, created, user, children}: {
    customerAction: boolean,
    created: LocalDateTime,
    user: string,
    children: React.ReactNode,
}) {
    return (
        <div className={`history-bubble ${customerAction ? 'left' : 'right'}`}>
            <div className="history-bubble__header">
                {created.format(minuteDateTimeFormatter())} {user.length > 0 && 'von'} {user}
            </div>
            <div className="history-bubble__content">
                {children}
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/InquiryDetails/InquiryHelperComponents/InquiryHistory.tsx